export default __webpack_public_path__ + "static/media/Mulheres-Unidas-contra-Bolsonaro-1.a8d4017c.jpg";